import { Button } from "@mui/material";
import { useAuth } from "../../context/AuthContext";
import { getAllUsersData } from "../utility/getAllUsersData";
import { getAllFirstDayAnswerData } from "../utility/getAllFirstDayANswerData";
import { jwtDecode } from "jwt-decode";

interface GetFirstDayAnswerDataComponentProps {
  setIsProgress: (isProgress: boolean) => void;
}

const downloadCSV = (csv: string, filename: string) => {
  const blob = new Blob([csv], { type: "text/csv" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
};

export const GetFirstDayAnswerDataComponent: React.FC<
  GetFirstDayAnswerDataComponentProps
> = ({ setIsProgress }) => {
  const { idToken, refreshAuthSession } = useAuth();

  const convertToCSV = (mergedData: any[]) => {
    // PANASのキー抽出
    const panasKeysSet = new Set<string>();
    // godspeedのキー抽出
    const godspeedKeysSet = new Set<string>();

    mergedData.forEach((user: any) => {
      user.answers.forEach((ans: any) => {
        // PANAS
        if (
          ans.date &&
          (ans.date.includes("pre") || ans.date.includes("post")) &&
          ans.answer &&
          ans.answer.panas
        ) {
          Object.keys(ans.answer.panas).forEach((key) => panasKeysSet.add(key));
        }
        // godspeed（postのみ）
        if (
          ans.date &&
          ans.date.includes("post") &&
          ans.answer &&
          ans.answer.godspeed
        ) {
          Object.keys(ans.answer.godspeed).forEach((key) =>
            godspeedKeysSet.add(key)
          );
        }
      });
    });

    const panasKeys = Array.from(panasKeysSet);
    const godspeedKeys = Array.from(godspeedKeysSet);

    // ヘッダー作成
    const headers = [
      "email",
      ...panasKeys.map((key) => `panas_pre_${key}`),
      ...panasKeys.map((key) => `panas_post_${key}`),
      ...godspeedKeys.map((key) => `godspeed_post_${key}`),
    ];

    // データ作成
    const rows = mergedData.map((user: any) => {
      const email = user.attributes?.email || "";
      // pre/postデータを抽出
      const preAnswer = user.answers.find(
        (ans: any) =>
          ans.date && ans.date.includes("pre") && ans.answer && ans.answer.panas
      );
      const postAnswer = user.answers.find(
        (ans: any) =>
          ans.date &&
          ans.date.includes("post") &&
          ans.answer &&
          ans.answer.panas
      );
      const godspeedAnswer = user.answers.find(
        (ans: any) =>
          ans.date &&
          ans.date.includes("post") &&
          ans.answer &&
          ans.answer.godspeed
      );
      const panasPreValues = panasKeys.map(
        (key) => preAnswer?.answer?.panas?.[key] ?? ""
      );
      const panasPostValues = panasKeys.map(
        (key) => postAnswer?.answer?.panas?.[key] ?? ""
      );
      const godspeedPostValues = godspeedKeys.map(
        (key) => godspeedAnswer?.answer?.godspeed?.[key] ?? ""
      );
      return [
        email,
        ...panasPreValues,
        ...panasPostValues,
        ...godspeedPostValues,
      ];
    });

    // CSV文字列生成
    const csv = [headers.join(","), ...rows.map((row) => row.join(","))].join(
      "\n"
    );
    return csv;
  };

  const mergeData = (userData: any[], answerData: any[]) => {
    // userIdごとにanswerDataをまとめる
    const answerMap: { [key: string]: any[] } = {};
    answerData.forEach((ans: any) => {
      if (!answerMap[ans.userId]) {
        answerMap[ans.userId] = [];
      }
      answerMap[ans.userId].push(ans);
    });

    // userDataとanswerDataを結合
    return userData.map((user: any) => {
      const answers = answerMap[user.username] || [];
      return {
        ...user,
        answers,
      };
    });
  };

  const getData = async () => {
    if (!idToken) {
      return;
    }

    // Adminアカウントの確認
    const decodedToken: any = jwtDecode(idToken);
    const userGroups = decodedToken["cognito:groups"] || [];
    if (!userGroups.includes("Admin")) {
      return;
    }

    setIsProgress(true);
    if (idToken) {
      const userData = await getAllUsersData(idToken);
      const answerData = await getAllFirstDayAnswerData(idToken);
      console.log(userData);
      console.log(answerData);
      const mergedData = mergeData(userData.users, answerData.data);
      console.log(mergedData);
      const csv = convertToCSV(mergedData);
      downloadCSV(csv, "first_day_panas.csv");
    }
    setIsProgress(false);
  };

  return (
    <>
      <Button variant="contained" onClick={getData}>
        初日アンケートデータ
      </Button>
    </>
  );
};
